import { useDispatch, useSelector } from 'react-redux';
import api from './axiosInstance.js';
import {
  setEmptyPastCreationData,
  setPastCreationData,
  setPastCreationError,
  setPastCreationLoading,
} from '../redux/pastCreateionsSlice.js';
import { setRecommendedPrompt } from '../redux/promptSlice.js';

export const usePastCreation = () => {
  const dispatch = useDispatch();

  const pastCreation = async (page, searchPrompt, signal) => {
    const params = new URLSearchParams();
    if (searchPrompt && searchPrompt.length > 0) {
      params.append('searchPrompt', searchPrompt);
    }
    params.append('page', page || 1);
    params.append('pageSize', 10);

    try {
      dispatch(setPastCreationLoading(true));
      const response = await api.get(`/history?${params.toString()}`, signal ? { signal } : {});
      if (page === 1) dispatch(setEmptyPastCreationData(true));
      dispatch(
        setPastCreationData({
          data: response.data.data,
          totalDocuments: response.data.totalDocuments,
          currentpage: response.data.currentPage,
          totalPage: response.data.totalPages,
        }),
      );
      const uniquePrompts = Array.from(
        new Map(
          response.data.data.map((item) => [item.prompt, item]),
        ).values(),
      ).slice(0, 5); 

      // dispatch(setRecommendedPrompt(uniquePrompts));
    } catch (error) {
      if (error.name === 'AbortError') {
        dispatch(setPastCreationLoading(true));
        return;
      } else {
        dispatch(setPastCreationError('Failed to fetch past creation'));
      }
    } finally {
      if (!signal.aborted) {
        dispatch(setPastCreationLoading(false));
      }
    }
  };

  return pastCreation;
};
